<script setup lang="ts">
import ApiService from '@/services/api_service';
import { i18n } from '@/plugins/i18n';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps({
  isVisible: {
    required: true,
    type: Boolean,
  },
  data: {
    required: true,
    type: JSON
  }
});

const localIsVisible = ref(props.isVisible);

const handleClose = () => {
  localIsVisible.value = false;
};

const markAsRead = async (notificationID: number) => {
  await ApiService.get(`api/fe/user-notification/${notificationID}/markAsRead`);
  handleClose();
};
const snooze = async (notificationID: number) => {
  await ApiService.get(`api/fe/user-notification/${notificationID}/snooze`);
  handleClose();
};

watch(() => props.isVisible, (newVal) => {
  localIsVisible.value = newVal;
});
</script>

<template>
  <el-drawer
    :model-value="localIsVisible"
    direction="ttb"
    :before-close="handleClose"
    class="animate__animated animate__bounceInDown"
    :class="{
      'app-notification-drawer-sucess !bg-[#ECF5FF] dark:!bg-blue-dark-menus': data.type === 'success',
      'app-notification-drawer-warning !bg-[#FDF6EC] dark:!bg-blue-dark-menus': data.type === 'warning',
      'app-notification-drawer-message !bg-[#F9F9F9] dark:!bg-blue-dark-menus': data.type === 'message',
    }"
    :show-close="false"
    :append-to-body="true"
  >
    <template #header="{ titleId }">
      <div class="flex flex-row justify-between pr-3 !max-w-[100%] !w-[100%]">
        <h4
          :id="titleId"
          class="text-white flex items-center fs-15 ml-5 !max-w-[85%] !w-[85%] whitespace-nowrap overflow-hidden !overflow-ellipsis"
        >
          <FontAwesomeIcon
            v-if="props.data.type === 'success'"
            :icon="['fal', 'circle-check']"
            class="light fs-15 hover:cursor-pointer mr-1"
          />
          <FontAwesomeIcon
            v-if="props.data.type === 'warning'"
            :icon="['fal', 'circle-exclamation']"
            class="light fs-15 hover:cursor-pointer mr-1"
          />
          <FontAwesomeIcon
            v-if="props.data.type === 'message'"
            :icon="['fal', 'circle-info']"
            class="light fs-15 hover:cursor-pointer mr-1"
          />
          <span>{{ props.data.title }}</span>
        </h4>

        <span id="close-drawer" class="text-white">
          <FontAwesomeIcon :icon="['fal', 'circle-xmark']" class="light fs-16 hover:cursor-pointer mt-[3px]" @click="snooze(props.data.id, 1)" />
          <FontAwesomeIcon :icon="['fas', 'circle-xmark']" class="solid hidden fs-16 hover:cursor-pointer mt-[3px]" @click="snooze(props.data.id, 1)" />
        </span>
      </div>
    </template>

    <div class="text-gray-y9-0">
      <div v-html="props.data.message" />
    </div>

    <div
      class="left-4 right-4 footer z-50 absolute bottom-0 py-4 flex justify-end"
      :class="{
        '!bg-[#ECF5FF] dark:!bg-blue-dark-menus': data.type === 'success',
        '!bg-[#FDF6EC] dark:!bg-blue-dark-menus': data.type === 'warning',
        '!bg-[#F9F9F9] dark:!bg-blue-dark-menus': data.type === 'message',
      }"
    >
      <el-button
        type="primary"
        data-cy="mark-as-read"
        round
        plain
        @click="snooze(props.data.id)"
      >
        <el-icon>
          <FontAwesomeIcon :icon="['fal', 'circle-check']" />
        </el-icon>
        <span>{{ i18n.global.t('general.remind_later') }}</span>
      </el-button>

      <el-button
        type="primary"
        data-cy="mark-as-read"
        round
        @click="markAsRead(props.data.id)"
      >
        <el-icon>
          <FontAwesomeIcon :icon="['fal', 'circle-check']" />
        </el-icon>
        <span>{{ i18n.global.t('menu.assistant.mark_as_read') }}</span>
      </el-button>
    </div>
  </el-drawer>
</template>

<style scoped>

</style>
